<template>
  <div id="issues-list">
    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead>
        <tr>
          <th class="align-middle">
            <ThOrder :textHeader="'Nº Contrato'" :idHeader="'contractId'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Id de incidente'" :idHeader="'incidentId'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>

          <th class="align-middle">
            <ThOrder :textHeader="'Estatus'" :idHeader="'status'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Fecha de creación'" :idHeader="'createdAt'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Prioridad'" :idHeader="'priority'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Fecha de cierre'" :idHeader="'closedAt'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Título'" :idHeader="'title'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Tipo'" :idHeader="'type'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle thOperaciones"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(issue) in issuesAux" :key="issue.clientId">
          <td class="py-4 align-middle">{{ issue.contractId }}</td>
          <td class="py-4 align-middle">{{ issue.incidentId }}</td>
          <td class="py-4 align-middle">
            <span v-if="issue.status === 'CREATED'" class="badge text-primary border border-primary">{{
              getTitle(issue.status) }}</span>
            <span v-else-if="issue.status === 'ASSIGNED'" class="badge text-secondary border border-secondary">{{
              getTitle(issue.status) }}</span>
            <span v-else-if="issue.status === 'IN_PROGRESS'" class="badge text-info border border-info">{{
              getTitle(issue.status) }}</span>
            <span v-else-if="issue.status === 'IN_ANALYSIS,'" class="badge text-warning border border-warning">{{
              getTitle(issue.status) }}</span>
            <span v-else-if="issue.status === 'DONE'" class="badge text-success border border-success">{{
              getTitle(issue.status) }}</span>
            <span v-else-if="issue.status === 'REJECTED'" class="badge text-danger border border-danger">{{
              getTitle(issue.status) }}</span>
            <span v-else class="badge text border">{{ getTitle(issue.status) }}</span>
          </td>
          <td class="py-4 align-middle">{{ $dateBackToFront(issue.createdAt) }}</td>
          <td class="py-4 align-middle">{{ priority(issue) }}</td>
          <td class="py-4 align-middle">{{ $dateBackToFront(issue.closedAt) }}</td>
          <td class="py-4 align-middle">{{ issue.title }}</td>
          <td class="py-4 align-middle">{{ type(issue) }}</td>
          <td id="operaciones" class="py-4 align-middle tdOperaciones">
            <div class="dropdown dropdown-inherit">
              <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                <a class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, issue, issue.status, 'issueDetail')">Ver
                  incidencia</a>
                <a class="dropdown-item py-3 px-4" href="#"
                  @click="openModals(index, issue, issue.status, 'issueEdit')">Editar
                  estatus</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div class="card p-2 mb-3 hola" v-for="(issue, index) in issuesAux" :key="index">
        <div class="list-item">
          <div class="item d-flex align-items-center justify-content-between px-2 py-3" data-toggle="collapse"
            :href="'#collapseExample' + index" role="button" aria-expanded="true"
            :aria-controls="'collapseExample' + index">
            <h4 class="m-0">{{ issue.requesterUsername }} - {{ priority(issue) }} - {{ issue.issueId }}</h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div class="collapse show ml-3 mr-2 borderFirstItem" :id="'collapseExample' + index">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2">
              <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
                <p class="m-0 mr-2"><strong>Nº contrato: </strong>{{ issue.contractId }}</p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, issue, issue.status, 'issueDetail')">Ver
                      incidencia</a>
                    <a class="dropdown-item py-3 px-4" href="#"
                      @click="openModals(index, issue, issue.status, 'issueEdit')">Editar
                      estatus</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Nº Incidencia: </strong>{{ issue.incidentId }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Estatus: </strong>{{ issue.status }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Fecha de creación: </strong>{{ $dateBackToFront(issue.createdAt) }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Prioridad: </strong>{{ priority(issue) }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Fecha de cierre: </strong>{{ $dateBackToFront(issue.closedAt) }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Título: </strong>{{ issue.title }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Tipo: </strong>{{ type(issue) }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>

    <IssueDetail :issue="issueSelected" :id="'issueDetail'" :modalTitle="'INFORMACIÓN DE LA INCIDENCIA'"
      v-if="showModalDetail" @closeModal="showModalDetail = false" :class="'modal-xl'"></IssueDetail>
    <IssueEdit :issue="issueSelected" :id="'issueEdit'" :modalTitle="'EDITAR ESTATUS DE LA INCIDENCIA'" :class="'modal-xl'"
      v-if="showModalEdit" @closeModal="showModalEdit = false" @sendRefreshIssuesList="sendRefreshIssuesList()">
    </IssueEdit>
    <NewComment :issue="issueSelected" :id="'newComment'" :modalTitle="'AÑADIR COMENTARIO'" :class="'modal-xl'"
      v-if="showModalComments" @closeModal="showModalComments = false"  @sendRefreshIssuesList="sendRefreshIssuesList()">
    </NewComment>

  </div>
</template>

<script>
import IssueDetail from './IssueDetail.vue';
import IssueEdit from './IssueEdit.vue';
import NewComment from './NewComment.vue';
import ThOrder from '../../../Shared/ThOrder.vue';
import { priorityData, priorityDataTraduction, incidentsTypes, incidentsTypesTraduction } from "../common.js";

//import axios from 'axios';
import { Modal as ModalBootstrap } from "bootstrap";


export default {
  name: 'IssuesList',
  props: [
    'issues',
  ],
  data() {
    return {
      currentOrder: '',
      currentOrderBy: '',
      issueSelected: '',
      issueStatus: '',
      issueIndex: '',
      issuesAux: this.issues,
      rol: this.$cookies.get('rol'),
      legalIdentifierSelected: '',
      showModalDetail: false,
      showModalEdit: false,
      showModalComments: false,
      priorityData: priorityData,
      priorityDataTraduction: priorityDataTraduction,
      incidentsTypes: incidentsTypes,
      incidentsTypesTraduction: incidentsTypesTraduction,

    };
  },
  updated() {
    this.issuesAux = this.issues
  },
  components: {
    IssueDetail,
    ThOrder,
    IssueEdit,
    NewComment
  },
  methods: {
    priority(issue) {
      return this.priorityData[this.priorityDataTraduction.indexOf(issue.priority)]
    },

    type(issue) {
      return this.incidentsTypes[this.incidentsTypesTraduction.indexOf(issue.type)]
    },
    selectOrder(value) {
      this.issuesAux = this.issuesAux.sort(function (a, b) {
        let valorA = a[value.orderBy] == null || a[value.orderBy] == undefined ? 0 : a[value.orderBy]
        let valorB = b[value.orderBy] == null || b[value.orderBy] == undefined ? 0 : b[value.orderBy]
        if (value.orderBy == "capacity") {
          valorA = parseInt(a[value.orderBy].slice(0, -2))
          valorB = parseInt(b[value.orderBy].slice(0, -2))
        }
        if (valorA < valorB) return -1
        if (valorA > valorB) return 1
      })
      if (value.order == 'DESC') this.issuesAux = this.issuesAux.reverse()
    },
    openModals: function (index, issue, status, identifier) {
      this.issueIndex = index;
      this.issueSelected = issue;
      this.issueStatus = status;

      switch (identifier) {

        case 'issueDetail':
          this.showModalDetail = true;
          break;
        case 'issueEdit':
          this.showModalEdit = true;
          break;
        case 'newComment':
          this.showModalComments = true;
          break;

      }
      this.$nextTick(() => {
        var myModal = new ModalBootstrap(document.getElementById(identifier))
        myModal.show()
      })
    },
    comprobarRolCompany() {
      let value = false
      if (this.rol != undefined && this.rol != null) {
        if (this.rol.includes('Backoffice_member_empresas')) {
          value = true
        }
      }
      return value
    },

    getTitle(title) {
      switch (title) {
        case 'CREATED':
          return 'CREADA';
        case 'ASSIGNED':
          return 'ASIGNADA';
        case 'IN_PROGRESS':
          return 'EN GESTIÓN';
        case 'IN_ANALYSIS':
          return 'EN ANÁLISIS';
        case 'DONE':
          return 'RESUELTA';
        case 'REJECTED':
          return 'NO RESUELTA';
        default:
          return title;
      }
    },

    sendRefreshIssuesList() {
     this.$emit('sendRefreshIssuesList')
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// #clients-list {
//   overflow: auto;
// }

.list-item h4 {
  font-size: 1rem;
}

#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

td {
  max-width: 15em;
}

th {
  max-width: 18em;
}

.col-12 {
  padding: 0%;
}
</style>
